var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"dense":_vm.dense,"items":_vm.items,"value":_vm.selectedValues,"multiple":"","label":_vm.$t(_vm.label)},on:{"change":value => _vm.$emit('change', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }